import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PhotoDisplay } from "./PhotoDisplay";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PhotoUploader = ({ label, value, onChange, multiple = false, token }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  
  const photos = multiple ? (value || []) : (Array.isArray(value) ? value : (value ? [value] : []));
  
  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    setUploading(true);
    const uploadedUrls = [];
    for (const file of files) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axios.post(`${API}/upload`, formData, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        });
        uploadedUrls.push(`${API}/files/${response.data.id}`);
      } catch (error) { toast.error(`Erreur upload: ${file.name}`); }
    }
    if (multiple) { onChange([...photos, ...uploadedUrls]); }
    else { onChange(uploadedUrls[0] || ''); }
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };
  
  const removePhoto = (index) => {
    if (multiple) { onChange(photos.filter((_, i) => i !== index)); }
    else { onChange(''); }
  };
  
  return (
    <div>
      <label className="label-uppercase block mb-2">{label}</label>
      {photos.length > 0 && (
        <div className={`grid ${multiple ? 'grid-cols-3' : 'grid-cols-1'} gap-2 mb-4`}>
          {photos.map((photo, idx) => (
            <div key={`${photo}-${idx}`} className="relative group">
              <PhotoDisplay url={photo} className="w-full aspect-square object-cover" />
              <button type="button" onClick={() => removePhoto(idx)}
                className="absolute top-1 right-1 w-6 h-6 bg-destructive text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                ×
              </button>
            </div>
          ))}
        </div>
      )}
      <div className="flex gap-2">
        <input ref={fileInputRef} type="file" accept="image/*" multiple={multiple} onChange={handleUpload} className="hidden" />
        <button type="button" onClick={() => fileInputRef.current?.click()} disabled={uploading}
          className="flex items-center gap-2 border border-border px-4 py-2 text-sm hover:bg-muted transition-colors disabled:opacity-50">
          {uploading ? (
            <><svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" strokeWidth="2" className="opacity-25" /><path strokeWidth="2" d="M4 12a8 8 0 018-8" className="opacity-75" /></svg>Upload en cours...</>
          ) : (
            <><svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>{multiple ? 'Ajouter des photos' : 'Choisir une photo'}</>
          )}
        </button>
      </div>
    </div>
  );
};
